$(function () {
  $('.community_main .media-grid').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    arrows: false,
    swipe: false,
    slidesToShow: 4,
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: false,
    rtl: true
  });
});



// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".product-card-wrapper").forEach(wrapper => {
//     const button = wrapper.querySelector(".product-card__quick-add-button");
//     const modal = wrapper.querySelector(".quick-view-modal");
//     const closeBtn = modal.querySelector(".quick-view-close");

//     button.addEventListener("click", () => {
//       modal.classList.add("active");
//     });

//     closeBtn.addEventListener("click", () => {
//       modal.classList.remove("active");
//     });
//   });
// });




// jQuery(document).ready(function($) {
//   // Setup modal behavior independently
//   $(document).on("click", ".product-card__quick-add-button", function (e) {
//     e.stopPropagation();
//     var $wrapper = $(this).closest(".product-card-wrapper");
//     var $modal = $wrapper.find(".quick-view-modal");

//     $modal.addClass("active");

//     // Close on mouse leave
//     $modal.off("mouseleave").on("mouseleave", function () {
//       $modal.removeClass("active");
//     });

//     // Close button
//     var $closeBtn = $modal.find(".quick-view-close");
//     $closeBtn.off("click").on("click", function (e) {
//       e.stopPropagation();
//       $modal.removeClass("active");
//     });
//   });

//   // Image slider on hover
//   $(document).on('click', '.product-card', function () {
//     const $card = $(this);
//     const $wrapper = $card.find('.product-card__media-slider-wrapper');
//     const $images = $wrapper.find('.product-card__image-slider-item');
//     const $prevBtn = $wrapper.find('.slider-btn.prev');
//     const $nextBtn = $wrapper.find('.slider-btn.next');
//     let index = 0;

//     function showImage(i) {
//       $images.addClass('hidden').eq(i).removeClass('hidden');
//     }

//     // Default: show first image only
//     showImage(0);
//     $prevBtn.hide();
//     $nextBtn.hide();

//     $card.on('mouseenter', function () {
//       $prevBtn.show();
//       $nextBtn.show();
//     });

//     $card.on('mouseleave', function () {
//       index = 0;
//       showImage(index);
//       $prevBtn.hide();
//       $nextBtn.hide();
//     });

//     $prevBtn.off("click").on('click', function (e) {
//       e.stopPropagation();
//       index = (index - 1 + $images.length) % $images.length;
//       showImage(index);
//     });

//     $nextBtn.off("click").on('click', function (e) {
//       e.stopPropagation();
//       index = (index + 1) % $images.length;
//       showImage(index);
//     });
//   });
// });



jQuery(document).ready(function($) {
  // Setup modal behavior independently
  $(document).on("click", ".product-card__quick-add-button", function (e) {
    e.stopPropagation();
    var $wrapper = $(this).closest(".product-card-wrapper");
    var $modal = $wrapper.find(".quick-view-modal");

    $modal.addClass("active");

    // Close on mouse leave
    $modal.off("mouseleave").on("mouseleave", function () {
      $modal.removeClass("active");
    });

    // Close button
    var $closeBtn = $modal.find(".quick-view-close");
    $closeBtn.off("click").on("click", function (e) {
      e.stopPropagation();
      $modal.removeClass("active");
    });
  });

  // Variables for slider
  let indexMap = new WeakMap();

  // Image slider behavior
  $(document).on('mouseenter', '.product-card', function () {
    const $card = $(this);
    const $wrapper = $card.find('.product-card__media-slider-wrapper');
    const $images = $wrapper.find('.product-card__image-slider-item');
    const $prevBtn = $wrapper.find('.slider-btn.prev');
    const $nextBtn = $wrapper.find('.slider-btn.next');

    let index = 0;
    indexMap.set($card[0], index); // Store index for this card

    $images.addClass('hidden').eq(index).removeClass('hidden');
    $prevBtn.show();
    $nextBtn.show();
  });

  $(document).on('mouseleave', '.product-card', function () {
    const $card = $(this);
    const $wrapper = $card.find('.product-card__media-slider-wrapper');
    const $images = $wrapper.find('.product-card__image-slider-item');
    const $prevBtn = $wrapper.find('.slider-btn.prev');
    const $nextBtn = $wrapper.find('.slider-btn.next');

    indexMap.set($card[0], 0);
    $images.addClass('hidden').eq(0).removeClass('hidden');
    $prevBtn.hide();
    $nextBtn.hide();
  });

  // Prev button click
  $(document).on('click', '.slider-btn.prev', function (e) {
    e.stopPropagation();
    const $btn = $(this);
    const $wrapper = $btn.closest('.product-card__media-slider-wrapper');
    const $card = $btn.closest('.product-card');
    const $images = $wrapper.find('.product-card__image-slider-item');

    let index = indexMap.get($card[0]) || 0;
    index = (index - 1 + $images.length) % $images.length;
    indexMap.set($card[0], index);

    $images.addClass('hidden').eq(index).removeClass('hidden');
  });


  $(document).on('click', '.slider-btn.next', function (e) {
    e.stopPropagation();
    const $btn = $(this);
    const $wrapper = $btn.closest('.product-card__media-slider-wrapper');
    const $card = $btn.closest('.product-card');
    const $images = $wrapper.find('.product-card__image-slider-item');

    let index = indexMap.get($card[0]) || 0;
    index = (index + 1) % $images.length; // Correct circular update
    indexMap.set($card[0], index);

    $images.addClass('hidden').eq(index).removeClass('hidden');
  });
});





document.addEventListener('DOMContentLoaded', function () {
  const backLink = document.querySelector('.breadcrumb-back-link');
  if (backLink && document.referrer && !document.referrer.includes(location.href)) {
    backLink.setAttribute('href', document.referrer);
  }
});



$(document).ready(function () {
  const selector = '.accordion__disclosure';

  // Summary click (toggle open/close)
  $(document).on('click', `${selector} summary`, function () {
    const $accordion = $(this).closest(selector);
    const $accordions = $(selector);

    // Delay to let native toggle finish
    setTimeout(function () {
      if ($accordion.prop('open')) {
        $accordions.each(function () {
          const $other = $(this);
          if ($other[0] !== $accordion[0] && $other.prop('open')) {
            $other.removeAttr('open').attr('aria-expanded', 'false');
          }
        });
        $accordion.attr('aria-expanded', 'true');
      } else {
        $accordion.attr('aria-expanded', 'false');
      }
    }, 0);
  });

  // When clicking input or checkbox inside accordion, still close others
  $(document).on('click', `${selector} input, ${selector} .checkbox-control`, function () {
    const $accordion = $(this).closest(selector);
    const $accordions = $(selector);

    if ($accordion.prop('open')) {
      $accordions.each(function () {
        const $other = $(this);
        if ($other[0] !== $accordion[0] && $other.prop('open')) {
          $other.removeAttr('open').attr('aria-expanded', 'false');
        }
      });
      $accordion.attr('aria-expanded', 'true');
    }
  });

  // Outside click – close all open accordions
  $(document).on('click', function (e) {
    $(selector).each(function () {
      const $accordion = $(this);
      if (
        $accordion.prop('open') &&
        !$.contains(this, e.target) &&
        !$(e.target).closest(selector).length
      ) {
        $accordion.removeAttr('open').attr('aria-expanded', 'false');
      }
    });
  });
});




$(document).on('click', 'li.header__search-link a[href="/search"], .header-search__form button', function(e) {
  e.preventDefault();
  $('.header-search__form input').val('');
  $('.predictive-search .predictive-search__content').empty();
});

$(document).ready(function () {
  $('.premium-fabrics-section .left-column ul.features button.button').on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 2000);
  });
});

// pagination button js

jQuery(document).ready(function($) {
  $(document).on('click', '.load-more-button', function () {
    var $button = $(this);
    var $wrapper = $button.closest('.load-more-wrapper');
    var nextPageUrl = $wrapper.data('next-page');
 
    if (!nextPageUrl) return;
 
    $button.text('Loading...');
 
    $.get(nextPageUrl, function(data) {
      var $data = $(data);
 
      var newProducts = $data.find('.product-list').html();
      var newLoadMore = $data.find('.load-more-wrapper');
 
      $('.product-list').append(newProducts);
 
      if (newLoadMore.length) {
        $wrapper.replaceWith(newLoadMore);
      } else {
        $wrapper.remove(); // All products loaded
      }
    });
  });
});

//---------- Cart item count update-----------------

document.addEventListener('DOMContentLoaded', () => {
  const badge = document.querySelector('.cart-count-badge');

  function refreshCart() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => badge.textContent = cart.item_count)
      .catch(console.error);
  }

  // Intercept XHR
  (function() {
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      this._url = url;
      this.addEventListener('load', () => {
        if (/\/cart\/(add|change|update|clear)\.js/.test(this._url)) {
          refreshCart();
        }
      });
      return origOpen.apply(this, arguments);
    };
  })();

  // Intercept fetch
  const origFetch = window.fetch;
  window.fetch = function(input, init) {
    return origFetch(input, init).then(response => {
      const url = typeof input === 'string' ? input : input.url;
      if (/\/cart\/(add|change|update|clear)\.js/.test(url)) {
        refreshCart();
      }
      return response;
    });
  };
});



